export const FETCH_START = 'fetchStart';
export const FETCH_END = 'fetchEnd';

export const SET_COMPANY_DEALERS = 'setCompanyDealers';
export const SET_COMPANY_SHIPPINGS = 'setCompanyShippings';
export const SET_COMPANY_SHIPPING_RATES = 'setCompanyShippingRates';

export const SET_LINKED_STORES = 'setLinkedStores';

export const SET_DELIVERY_COMPANY = 'setDeliveryCompany';
export const SET_DELIVERY_COMPANIES = 'setDeliveryCompanies';

export const SET_DELIVERY_MODE_RATE = 'setDeliveryModeRate';

